<template>
    <order-summary-layout
        :total-price="totalPrice"
        :product-store="productStore"
        :extra-prices="extraPrices"
        :search-request="searchRequest"
    >
        <car-offer-card-mobile :product="{offer, info}" :book-disabled="true" hide-map>
            <template v-slot:summary>
                <slot name="summary" />
            </template>
        </car-offer-card-mobile>
        <div class="mt-1 font-weight-bold">
            <span>
                {{ $filters.price(offerPrice) }}
            </span>
            <commission-amount :commission="offer.price.commission" />
            <net-amount :search-request="searchRequest" :price="offer.price" />
        </div>
        <extra-services-summary
            v-if="extraServices && additionalOptions"
            :extra-services="extraServices"
            :additional-options="additionalOptions"
        />
    </order-summary-layout>
</template>

<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator'
    import OrderSummaryLayout from '@/components/booking/OrderSummaryLayout.vue'
    import CarOfferCardMobile from '@/components/carsRent/search/offers/CarOfferCardMobile.vue'
    import ExtraServicesSummary from '@/components/booking/snippets/ExtraServicesSummary.vue'
    import CommissionAmount from '~/components/snippets/CommissionAmount.vue'
    import NetAmount from '~src/components/snippets/NetAmount.vue'
    import {clone} from '@/utils/helpers'
    import {OrderSummaryBase} from '@/components/booking/OrderSummaryBase.vue'

    @Component({
        components: {
            ExtraServicesSummary,
            OrderSummaryLayout,
            CarOfferCardMobile,
            CommissionAmount,
            NetAmount,
        },
    })
    export class CarOrderSummary extends OrderSummaryBase {
        @Prop({required: true}) offer
        @Prop({required: true}) info
        @Prop({default: true}) prebooked

        get productStore() {
            return carsRentStore
        }

        get offerPrice() {
            const price = clone(this.offer.price)
            const mandatory =
                this.productStore.bookingAdditionalOptions?.extraServices?.filter(
                    extraService => extraService.mandatory
                ) || []

            if (mandatory.length) {
                mandatory.forEach(item => {
                    price.amount -= item.salesTerms.find(el => el.type === 'CLIENT').price.amount
                    price.originalAmount -= item.salesTerms.find(el => el.type === 'CLIENT').originalAmount
                })
            }

            return price
        }

        get orderTotalPrice() {
            return carsRentStore.orderTotalPrice(this.offer, this.prebooked, [], this.prepareBookResponse)
        }
    }

    export default CarOrderSummary
</script>
